<template>
  <div class="border">
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id"],
  created() {
    this.itemLink += `/${this.id}/loans`;
    this.setLink += `/${this.id}/loans`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "bank",
          labelKey: "bank_select",
          label: "Выберите банк",
          type: "select",
          modal: "bank",

          selectKey: "name",
        },
        {
          col: " col-12 col-md-6",
          key: "loan_amount_desired",
          labelKey: "loan_amount_desired",
          label: "Сумма кредита",
          type: "field",
          price: true,
          textType: "number",
        },
        {
          col: " col-12 col-md-6",
          key: "loan_term_desired",
          labelKey: "loan_term_desired",
          label: "Срок кредита",
          type: "field",
          price: true,
          textType: "number",
        },
        {
          key: "loan_goal",
          labelKey: "loan_goal",
          label: "Цель кредита",
          type: "hidden",
          default: "Пополнение оборотных средств",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_loan",
      itemLink: "dealers",
      setLink: "dealers",
      columns: [
        {
          key: "id",
          titleKey: "id",
          title: "ID",
        },
        {
          key: "bank",
          titleKey: "bank",
          object: "name",
          title: "Банк",
          disableLink: true,
        },
        {
          key: "loan_amount_desired",
          titleKey: "loan_amount_desired",
          title: "Сумма кредита",
        },
        {
          key: "loan_term_desired",
          titleKey: "loan_term_desired",
          title: "Срок кредита",
        },
        {
          key: "loan_goal",
          titleKey: "loan_goal",
          title: "Цель кредита",
        },
        {
          key: "created_at",
          titleKey: "created_at",
          dateTimeFormat: true,
          title: "Дата создания",
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
